import React from 'react';
import moment from 'moment';
import Formsy from 'formsy-react';
import Modal from '../shared/Modal';
import Select from '../form/Select';
import DatePicker from '../form/DatePicker';
import { getHourOptions, genHourOption } from '../../helpers/hourOptions';
import withSplashMessage from '../splashMessage/withSplashMessage';
import { hoursOfOperation } from '../../const';

class ChefTimeOffModal extends React.Component {
  state = {
    id: 0,
    start_time: {},
    end_time: {},

    startHourOptions: [],
    endHourOptions: []
  };

  render() {
    const { start_time, end_time } = this.state;
    const { isOpen, closeModal } = this.props;
    const isNew = this.props.index < 0;

    return (
      <Modal isOpen={isOpen} onRequestClose={closeModal}>
        <Formsy className="form" onValidSubmit={this.handleSubmit}>
          <h2 className="h2 modal__heading">
            {isNew ? 'Add' : 'Edit'} Time Off
          </h2>

          <div className="form__row form__row--spacer">
            <div className="form__row-item form__row-item--half">
              <p className="simple-input__label">Start Date</p>
              <DatePicker
                name="start_time"
                value={
                  start_time && 'datetime' in start_time
                    ? start_time.datetime
                    : new Date()
                }
                minDate={new Date()}
                onChange={this.handleDateChange}
              />
            </div>

            <div className="form__row-item form__row-item--half">
              <p className="simple-input__label">Start Time</p>
              {this.renderHourSelect('start_time', this.state.start_time)}
            </div>
          </div>

          <div className="form__row form__row--spacer">
            <div className="form__row-item form__row-item--half">
              <p className="simple-input__label">End Date</p>
              <DatePicker
                name="end_time"
                value={
                  end_time && 'datetime' in end_time
                    ? end_time.datetime
                    : new Date()
                }
                activeStartDate={
                  start_time && 'datetime' in start_time
                    ? start_time.datetime.toDate()
                    : new Date()
                }
                minDate={
                  start_time && 'datetime' in start_time
                    ? start_time.datetime.toDate()
                    : new Date()
                }
                onChange={this.handleDateChange}
              />
            </div>

            <div className="form__row-item form__row-item--half">
              <p className="simple-input__label">End Time</p>
              {this.renderHourSelect('end_time', this.state.end_time)}
            </div>
          </div>

          <div className="form__row">
            <div className="form__row-item--half">
              <div
                className="btn btn--hollow-red-bright btn--full-width"
                onClick={closeModal}
              >
                Cancel
              </div>
            </div>
            <div className="form__row-item--half">
              <input
                type="submit"
                className="btn btn--solid-blue btn--full-width"
                value="Save"
              />
            </div>
          </div>
        </Formsy>
      </Modal>
    );
  }

  renderHourSelect(name, value) {
    const hourOptions =
      name === 'start_time'
        ? this.state.startHourOptions
        : this.state.endHourOptions;
    return (
      <Select
        name={name}
        value={value}
        options={hourOptions}
        onChange={value => this.handleSelectChange(name, value)}
        required
      />
    );
  }

  handleSelectChange = (name, value) => this.setState({ [name]: value });

  handleDateChange = (date, name) => {
    const { start_time, end_time } = this.state;
    const state = {};

    if (name === 'start_time') {
      const oldStart = moment(
        start_time && 'datetime' in start_time
          ? start_time.datetime
          : new Date()
      );
      const newStart = oldStart
        .year(date.year())
        .month(date.month())
        .date(date.date());

      state.start_time = genHourOption(newStart);
      state.startHourOptions = getHourOptions(moment(date));
    }

    if (name === 'end_time') {
      const oldEnd = moment(
        end_time && 'datetime' in end_time ? end_time.datetime : new Date()
      );
      const newEnd = oldEnd
        .year(date.year())
        .month(date.month())
        .date(date.date());

      state.end_time = genHourOption(newEnd);
      state.endHourOptions = getHourOptions(moment(date));
    }

    this.setState(state);
  };

  handleSubmit = e => {
    const time_off = {
      start_time: this.state.start_time.datetime.toISOString(),
      end_time: this.state.end_time.datetime.toISOString()
    };

    if (this.state.id > 0) time_off.id = this.state.id;

    // update
    if (this.props.index >= 0) {
      const chef_time_offs = [
        ...this.props.chef_time_offs.slice(0, this.props.index),
        time_off,
        ...this.props.chef_time_offs.slice(
          this.props.index + 1,
          this.props.chef_time_offs.length
        )
      ];
      this.props.updateChef({ chef_time_offs });
    }
    // create
    else {
      const chef_time_offs = [...this.props.chef_time_offs];
      chef_time_offs.push(time_off);
      this.props.updateChef({ chef_time_offs });
    }
  };

  deriveState() {
    const defaultStartDate = moment()
      .set('hour', hoursOfOperation.open)
      .startOf('hour')
      .toDate();
    const defaultCloseDate = moment()
      .set('hour', hoursOfOperation.close)
      .startOf('hour')
      .toDate();
    const { chef_time_offs = [], index = -1 } = this.props;
    const timeOff = index >= 0 ? chef_time_offs[index] : {};
    const {
      id = 0,
      start_time: startTime = defaultStartDate,
      end_time: endTime = defaultCloseDate
    } = timeOff;

    const start_time = genHourOption(moment(startTime));
    const startHourOptions = getHourOptions(start_time.datetime);

    const end_time = genHourOption(moment(endTime));
    const endHourOptions = getHourOptions(end_time.datetime);

    return { id, start_time, end_time, startHourOptions, endHourOptions };
  }

  componentDidUpdate(prevProps) {
    // update state from props
    if (this.props.isOpen && this.props.isOpen !== prevProps.isOpen) {
      const state = this.deriveState();
      this.setState(state);
    }
  }
}
export default withSplashMessage(ChefTimeOffModal);



// WEBPACK FOOTER //
// ./src/components/chef/ChefTimeOffModal.js